
import { defineComponent, computed, ref } from 'vue'
import BaseTree from '@/views/dashboard/_components/group-tree/base-tree.vue'
import { Group } from '@/views/dashboard/_type/group'
export default defineComponent({
  name: 'ClientMoveTerminalModal',
  components: {
    BaseTree
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    count: {
      type: Number,
      default: 0
    }
  },
  emits: ['closeClientModal', 'reloadData', 'moveTerminal'],
  setup (props, context) {
    const modalVisiable = computed(() => props.show)
    const newGrpId = ref<number>(-1)
    return {
      modalVisiable,
      moveTerminal () {
        context.emit('moveTerminal', newGrpId.value)
        context.emit('closeClientModal', 'MODAL_CLIENT_MOVE_TERMINAL')
      },
      terminalGroupSelected (row: Group) {
        newGrpId.value = row.group_id
      },
      closeModal () {
        context.emit('closeClientModal', 'MODAL_CLIENT_MOVE_TERMINAL')
      }
    }
  }
})
